import { Injectable, Injector } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { HttpService } from "app/services/base/http.service";
import { environment } from "environments/environment";
import { authInterface } from "api-interface/auth.interface";
import { AccountModel } from "app/model/auth.account.model";
import * as CryptoJS from 'crypto-js';



@Injectable()
export class AuthService extends HttpService {

    /**
     * アカウント情報
     * キャッシュ用
     */
    private accountInfo: AccountModel;
    private accountLoaded = false;

    constructor(private injector: Injector) {
        super(injector);
    }


    /**
     * ログインしたユーザ情報を取得する
     */
    public async getAccount(): Promise<AccountModel> {

        if (!this.accountLoaded) {
            this.accountInfo = await this.get<authInterface.account.GetRes>('/auth/account');
            this.accountLoaded = true;
        }
        return this.accountInfo;
    }


    /**
     * システム管理者のログイン処理
     */
    public async login(username: string, password: string, recaptcha: string) {

        let loginInfo: authInterface.login.PostReq = {
            username: username,
            password: '',
            recaptcha: recaptcha
        };
        
        // ハッシュ値を取る
        let hash = CryptoJS.SHA256(password).toString();
        loginInfo.password = CryptoJS.SHA256(hash + loginInfo.username).toString();

        await this.post('/auth/login', loginInfo);
    }
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/services/auth/auth.service.ts